import { render, staticRenderFns } from "./SerpResultsExportButton.vue?vue&type=template&id=64d06efd&scoped=true"
import script from "./SerpResultsExportButton.vue?vue&type=script&lang=js"
export * from "./SerpResultsExportButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d06efd",
  null
  
)

export default component.exports